import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';
import { NgxSpinnerService } from 'ngx-spinner'; // 1. Import the spinner

@Component({
  selector: 'app-juspay-callback',
  templateUrl: './juspay-callback.component.html',
  styleUrls: ['./juspay-callback.component.scss'],
  standalone: false
})
export class JuspayCallbackComponent implements OnInit {
  isSuccess: boolean | null = null; 
  orderId: string = '';

  constructor(
    private activeRouter: ActivatedRoute,
    private router: Router,
    private storageService: StorageService,
    private spinner: NgxSpinnerService 
  ) {}

  ngOnInit(): void {
    this.spinner.hide();
    this.activeRouter.queryParams.subscribe((params) => {
      this.orderId = params.order_id || 'N/A';
      
      if (params.status === 'CHARGED') {
          this.isSuccess = true;
          this.storageService.setOrderId(this.orderId);
          this.storageService.setPaymentStatus("payment_successfull");
        } else {
          this.isSuccess = false;
        this.storageService.setPaymentStatus("payment_failed");
      }

      // Trigger the storage event to notify AdminSideNavComponent
      const paymentUpdate = {
        status: params.status,
        timestamp: new Date().getTime() 
      };
      localStorage.setItem('doqfy_payment_update', JSON.stringify(paymentUpdate));
    });
  }

  goToDashboard() {
    this.router.navigate(['doqfy/admin-dashboard']);
  }
}